var React = require('react');

function BagInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"bag.inline"),React.createElement("g",{"id":"f5dd05a4-01e0-45ad-860c-46b707b80765","data-name":"Layer 2","key":1},React.createElement("g",{"id":"fd72764c-cda0-49a5-babc-bf42d8c4d422","data-name":"Layer 1"},React.createElement("g",{"id":"adbedeff-6583-4b3c-a06f-e919b50434e7","data-name":"bag.inline"},React.createElement("path",{"d":"M7.29,25.92v1.62m27.54-4.05H4.05M30,38.07a8.1,8.1,0,0,1,8.1-8.1M8.91,38.07A8.1,8.1,0,0,0,.81,30m37.26-7.29a7.29,7.29,0,0,0-7.29-7.29H8.1A7.29,7.29,0,0,0,.81,22.68V33.21a4.87,4.87,0,0,0,4.86,4.86H33.21a4.87,4.87,0,0,0,4.86-4.86ZM11.34,18.63V8.91a8.1,8.1,0,1,1,16.2,0v9.72","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

BagInline.defaultProps = {"viewBox":"0 0 38.88 38.88"};

module.exports = BagInline;

BagInline.default = BagInline;
